export default {
  title: "探索 Kozmap".toUpperCase(),
}
